// This file is generated by `pnpm --filter @forge/web generate:ui-locales`.
// Do not edit it by hand; add or remove apps/web/messages/*.json instead.

export const DEFAULT_LOCALE = "en" as const

export const AVAILABLE_UI_LOCALES = [
  "ab",
  "ady",
  "af",
  "ak",
  "am",
  "ar",
  "as",
  "ast",
  "av",
  "ay",
  "az",
  "az-Arab",
  "az-Cyrl",
  "ba",
  "be",
  "bg",
  "bi",
  "bjt",
  "bn",
  "bo",
  "bs",
  "bs-Cyrl",
  "bsc",
  "bua",
  "ca",
  "caa",
  "cak",
  "ce",
  "ceb",
  "ch",
  "chp",
  "ckb",
  "crk",
  "cs",
  "csb",
  "cy",
  "da",
  "de",
  "den",
  "dgr",
  "dv",
  "dyo",
  "dz",
  "ee",
  "el",
  "en",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fil",
  "fj",
  "fo",
  "fr",
  "frr",
  "fy",
  "ga",
  "gaa",
  "gd",
  "gil",
  "gl",
  "gn",
  "gsw",
  "gu",
  "gv",
  "gwi",
  "hak-Hant",
  "haw",
  "he",
  "hi",
  "hif",
  "hil",
  "ho",
  "hr",
  "ht",
  "hu",
  "hy",
  "id",
  "ilo",
  "inh",
  "is",
  "it",
  "iu",
  "iu-Latn",
  "ixl",
  "ja",
  "ka",
  "kbd",
  "kg",
  "kha",
  "kk",
  "kl",
  "km",
  "kn",
  "knf",
  "ko",
  "koi",
  "kok",
  "krc",
  "ks",
  "kum",
  "kv",
  "ky",
  "lb",
  "lbe",
  "lez",
  "ln",
  "lo",
  "lt",
  "lua",
  "lv",
  "mai",
  "mdf",
  "mdh",
  "mey-Latn",
  "mfv",
  "mg",
  "mh",
  "mi",
  "mk",
  "ml",
  "mn",
  "mn-Mong",
  "mr",
  "ms",
  "ms-Arab",
  "mt",
  "my",
  "myv",
  "na",
  "nan-Hant",
  "nb",
  "nd",
  "ne",
  "nl",
  "nn",
  "no",
  "nr",
  "nso",
  "ny",
  "oc",
  "or",
  "os",
  "pa",
  "pag",
  "pap",
  "pau",
  "pl",
  "ps",
  "pt",
  "qu",
  "quc",
  "quv",
  "rm",
  "rn",
  "ro",
  "ru",
  "rw",
  "sa",
  "sah",
  "sat",
  "sav",
  "sd",
  "sd-Deva",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sms",
  "sn",
  "snf",
  "so",
  "sq",
  "sr",
  "sr-Latn",
  "srr",
  "ss",
  "st",
  "sv",
  "sw",
  "ta",
  "te",
  "tet",
  "tg",
  "th",
  "tk",
  "tl",
  "tn",
  "tnr",
  "to",
  "tpi",
  "tr",
  "ts",
  "tsg",
  "tt",
  "tvl",
  "ty",
  "tyv",
  "tzm",
  "udm",
  "ug",
  "uk",
  "ur",
  "usp",
  "uz",
  "uz-Arab",
  "uz-Cyrl",
  "ve",
  "vec",
  "vi",
  "war",
  "wo",
  "xh",
  "xin",
  "yo",
  "yue",
  "za",
  "zh",
  "zh-Hans",
  "zh-Hant",
  "zu",
] as const

export type UiLocale = (typeof AVAILABLE_UI_LOCALES)[number]

const AVAILABLE_UI_LOCALE_SET: ReadonlySet<string> = new Set(
  AVAILABLE_UI_LOCALES,
)

export function hasUiLocale(candidate: string): candidate is UiLocale {
  return AVAILABLE_UI_LOCALE_SET.has(candidate)
}
